module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.swapPaymentMethod) ? _c('div', {
    directives: [{
      name: "cb-animate",
      rawName: "v-cb-animate",
      value: (true),
      expression: "true"
    }],
    staticClass: "cb-body__wrap"
  }, [_c('div', {
    staticClass: "cb-body__content"
  }, [((!_vm.editMode && _vm.skip_cart) || _vm.subscribeMode) ? [_c('cart-fixed', {
    attrs: {
      "edit-order": true,
      "nav-icon": 'right'
    }
  })] : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('payment-component', {
    attrs: {
      "payment-method-type": _vm.payment_method_type
    },
    on: {
      "setPaymentType": function($event) {
        _vm.setPaymentType($event)
      },
      "renderRecaptcha": function($event) {
        _vm.renderRecaptcha()
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "parent",
    staticClass: "cb-transition__tab",
    attrs: {
      "reCalculateMargin": true
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c(_vm.componentType(), {
    tag: "component",
    staticClass: "cb-transition__tab",
    attrs: {
      "pm": _vm.pm,
      "edit-mode": _vm.editMode,
      "subscribe-mode": _vm.subscribeMode
    },
    on: {
      "submit": function($event) {
        _vm.submit()
      }
    }
  })], 1)], 1)], 2), _vm._v(" "), (!_vm.subscribeMode && _vm.showTopLevelPaymentButton()) ? [_c('div', {
    staticClass: "cb-body__footer"
  }, [_c('cb-notes', {
    attrs: {
      "custom-class": 'cb-section',
      "type": 'info',
      "message": _vm.paymentNote
    }
  }), _vm._v(" "), _c('cb-button', {
    attrs: {
      "custom-class": 'primary',
      "show-loader": _vm.showLoader,
      "attr": 'card_payment_submit'
    },
    on: {
      "next": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.buttonTxt) + "\n        ")])], 1)] : _vm._e(), _vm._v(" "), (_vm.subscribeMode) ? [_c('checkout-subscribe', {
    attrs: {
      "custom-class": 'cb-body__footer cb-body__footer--text',
      "show-loader": _vm.showLoader,
      "hide-button-override": !_vm.showTopLevelPaymentButton()
    },
    on: {
      "submit": function($event) {
        _vm.submit()
      }
    }
  }, [_c('cb-notes', {
    attrs: {
      "custom-class": 'cb-section',
      "type": 'info',
      "message": _vm.paymentNote
    },
    slot: "notes"
  }), _vm._v(" "), _c('div', {
    staticClass: "cb-subscribe"
  }, [_c('i', {
    staticClass: "icon-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.st('checkout_message')) + " " + _vm._s(_vm.st('chargebee_checkout')))])], 1)] : _vm._e(), _vm._v(" "), (this.payment_method_type == 'card' && this.pm && this.pm.enabled3ds) ? _c('cb-notes', {
    staticClass: "cb-notebar--footer",
    attrs: {
      "type": 'muted',
      "message": _vm.threedsNote
    },
    slot: "notes"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recaptchaVerification),
      expression: "recaptchaVerification"
    }],
    ref: "recaptcha_container",
    staticClass: "google-recaptcha"
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9f1f0ca"}!./src/components/collections/templates/PaymentTemplate.html
// module id = 612
// module chunks = 66